<template>
  <v-dialog v-model="modal.active" width="50%" persistent    >
    <v-card>
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="font-weight-bold py-2 pl-4 fs-16px">
          <v-icon left>fal fa-plus fs-14px</v-icon>
          Create Dashboard widget
        </v-card-title>
      </div>
      <v-divider></v-divider>
      <v-card-text class="pt-2" style="height: 50vh;">
        <div class="d-flex align-center">
          <v-text-field style="flex-grow: 1;" v-model="queryText" placeholder="Enter your query here for ex: display projects by status as pie chart" width="80%">
          </v-text-field>
          <v-btn class="ml-2" color="primary" @click="queryHandler" :loading="queryLoading">Generate</v-btn>

        </div>
        <div class="d-flex justify-center mt-5" style="height: 100%;">
            <DashboardWidget  v-if="widget" :message="widget" style="width:100%;height: 100%;"></DashboardWidget>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn elevation="0" text small :disabled="modal.loading" @click="closeHandler">
          Close
        </v-btn>
        <v-btn :disabled="!widget || modal.loading" :loading="modal.loading" small color="primary"
          @click="confirmHandler">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
/* eslint-disable  */
 import DashboardWidget from '@/features/Chatbot/components/dashboard-widget.vue';
 import apiService from '../service/dashboard-widgets.service';
 import { log, warn, error } from '@/utils/debugLogger';
export default {
  components:{
    DashboardWidget
  },
 
    data() {
      return {
        modal:{
            active: false,
            valid: false,
            loading: false,
        },
        queryText:'',
        queryLoading:false,
        widget:null,
        widgetId:null
      };
    },
    methods: {
      open(widget) {
        if ( widget) {
                this.widgetId = widget.id;
                this.getWidget();
            }
            else {
                this.createNewWidget();
            }
        this.reset();
        this.modal.active = true;
      },
      queryHandler() {
        this.queryLoading = true;
        var payLoad=structuredClone(this.widget||{
          width:1,
          height:1,  
          aiGenerated:true
        });
        payLoad.prompt=this.queryText;
        this.widget=null;
        this.generate(payLoad).then(res => {
          this.widget=this.mapEntity(res);
          
        }
        ).finally(() => {
          this.queryLoading = false;
        });
      },
      closeHandler() {
        this.reset();
        this.modal.active=false;
       
      },
      reset(){
        this.widget=null;
        this.queryText=null;
        this.queryLoading=false;
      },
      confirmHandler() {
        this.modal.active=false;
        this.$emit('updated',this.widget);
      },

      createNewWidget(){
           
        },
        getWidget(){
            this.loading=true;
                this.query(this.widgetId).then(res=>{
                    this.widget=res;
                    this.queryText=this.widget.prompt;
                    this.loading=false;
                })
        },
      mapEntity(widget) {

        widget.w = widget.width;
        widget.h = widget.height;

        try {
          if (widget.content)
            widget.content = JSON.parse(widget.content);

          if (!widget.aiGenerated) {
            if (widget.legend)
              widget.legend = JSON.parse(widget.legend);
            if (widget.columns)
              widget.columns = JSON.parse(widget.columns);
          }
        
        } catch (error) { }

        return widget;
      },
  generate(widget){
    return apiService.generate(widget).then(res=>{
           this.widget=this.mapEntity(res.data);
            }).catch(err=>{
               error('EditAIWidget', 'generate error', err);
            });


        },
        create(widget){
          return apiService.create(widget).then(res=>{
            this.widget=mapEntity(res.data);
            }).catch(err=>{
             error('EditAIWidget', 'create error', err);
            });
        }
    },
}
</script>

<style>

</style>